// extracted by mini-css-extract-plugin
export default {"history":"History_history__0Pt2f","section":"History_section__4mUff"};